import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Input from "../../../../../../../components/textbox/Input";

class DatiClinici extends Component {

    state = {
        datiClinici: {
            comuneInsorgenzaSintomi: "",
            esantemaMaculoPapulare: "",
            dataComparsaEsantema: "",
            febbre: "",
            dataComparsaFebbre: "",
            statoGravidanza: "",
            dataUltimaMestruazione: "",
            rinite: "",
            congiuntivite: "",
            tosse: "",
            adenopatia: "",
            artralgia: "",
            artrite: "",
            altro: "",
            corretto: []

        },
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),

    }


    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let datiClinici = this.state.datiClinici
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiClinici) {
            let datiCliniciCopia = this.props.segnalazioneCopia.schedaSpeciale.datiClinici
            for (let key in datiClinici) {
                if (datiClinici.hasOwnProperty(key) === datiCliniciCopia.hasOwnProperty(key)) {
                    if (key === "comuneInsorgenzaSintomi") {
                        datiClinici[key] = this.state.comuniPerCodice[datiCliniciCopia[key]] ? this.state.comuniPerCodice[datiCliniciCopia[key]] : ""
                    } else {
                        datiClinici[key] = datiCliniciCopia[key]
                    }
                } else {
                    datiClinici[key] = ""
                }
            }

        } else if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.datiSanitari) {
            datiClinici.comuneInsorgenzaSintomi = this.props.segnalazioneCopia.datiSanitari.comuneInizioSintomi ?
                this.state.comuniPerCodice[this.props.segnalazioneCopia.datiSanitari.comuneInizioSintomi] : ""
        }

        this.setState({datiClinici: datiClinici})
        this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        let corretto = datiClinici.corretto
        this.props.createOggettoBeAndcontrolloCorrettezza("datiClinici", oggettoBE, corretto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiClinici", oggettoBE, this.state.datiClinici.corretto, this.validate())
        }
    }

    validate() {

        if (this.state.datiClinici.dataComparsaEsantema && Utils.validateDate(this.state.datiClinici.dataComparsaEsantema, "Messages.DataComparsaEsantema", "Messages.DataComparsaEsantemaOdierna")) {
            return Utils.validateDate(this.state.datiClinici.dataComparsaEsantema, "Messages.DataComparsaEsantema", "Messages.DataComparsaEsantemaOdierna")
        }
        if (this.state.datiClinici.dataComparsaFebbre && Utils.validateDate(this.state.datiClinici.dataComparsaFebbre, "Messages.DataComparsaFebbre", "Messages.DataComparsaFebbreOdierna")) {
            return Utils.validateDate(this.state.datiClinici.dataComparsaFebbre, "Messages.DataComparsaFebbre", "Messages.DataComparsaFebbreOdierna")
        }
        if (this.state.datiClinici.dataUltimaMestruazione && Utils.validateDate(this.state.datiClinici.dataUltimaMestruazione, "Messages.DataUltimaM", "Messages.DataUltimaMOdierna")) {
            return Utils.validateDate(this.state.datiClinici.dataUltimaMestruazione, "Messages.DataUltimaM", "Messages.DataUltimaMOdierna")
        }

        if (this.state.datiClinici.esantemaMaculoPapulare !== "1" && this.state.datiClinici.dataComparsaEsantema) return "Messages.ERR_01_02_0G_BL"
        else if (this.state.datiClinici.febbre !== "1" && this.state.datiClinici.dataComparsaFebbre) return "Messages.ERR_01_02_0G_BM"
        else if (this.state.datiClinici.statoGravidanza !== "1" && this.state.datiClinici.dataUltimaMestruazione) return "Messages.ERR_01_02_0G_BN"

        return ""

    }

    riceviValore(field, event) {
        let datiClinici = this.state.datiClinici
        datiClinici[field] = event.target.value

        this.setState({datiClinici: datiClinici})
        this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        let corretto = datiClinici.corretto
        this.props.createOggettoBeAndcontrolloCorrettezza("datiClinici", oggettoBE, corretto)
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.datiClinici))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        oggettoBE.comuneInsorgenzaSintomi = oggettoBE.comuneInsorgenzaSintomi && oggettoBE.comuneInsorgenzaSintomi.codice ? oggettoBE.comuneInsorgenzaSintomi.codice : ""
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let datiClinici = this.state.datiClinici
        datiClinici.corretto = []

        if(!datiClinici.rinite) datiClinici.corretto[0] = "Campo \"Rinite\" mancante";
        if(!datiClinici.congiuntivite) datiClinici.corretto[1] = "Campo \"Congiuntivite\" mancante";
        if(!datiClinici.tosse) datiClinici.corretto[2] = "Campo \"Tosse\" mancante";
        if(!datiClinici.adenopatia) datiClinici.corretto[3] = "Campo \"Adenopatia(cervicale,suboccipitale,retroauricolare)\" mancante";
        if(!datiClinici.artralgia) datiClinici.corretto[4] = "Campo \"Artralgia\" mancante";
        if(!datiClinici.artrite) datiClinici.corretto[5] = "Campo \"Artrite\" mancante";
        if(!datiClinici.altro) datiClinici.corretto[6] = "Campo \"Altri sintomi,specificare\" mancante";
        if(datiClinici.esantemaMaculoPapulare === "1" && (!datiClinici.dataComparsaEsantema || (datiClinici.dataComparsaEsantema && Utils.isDateInValid(Utils.transformDateForBackend(datiClinici.dataComparsaEsantema), "-")))) datiClinici.corretto[7] = "Campo \"Data comparsa esantema\" mancante o errato";
        if(datiClinici.febbre === "1" && (!datiClinici.dataComparsaFebbre || (datiClinici.dataComparsaFebbre && Utils.isDateInValid(Utils.transformDateForBackend(datiClinici.dataComparsaFebbre), "-")))) datiClinici.corretto[8] = "Campo \"Data comparsa febbre\" mancante o errato";
        if(datiClinici.statoGravidanza === "1" && (!datiClinici.dataUltimaMestruazione || (datiClinici.dataUltimaMestruazione && Utils.isDateInValid(Utils.transformDateForBackend(datiClinici.dataUltimaMestruazione), "-")))) datiClinici.corretto[9] = "Campo \"Se si, data ultima mestruazione\" mancante o errato";

        return this.setState({datiClinici: datiClinici})
    }


    render() {
        const {t} = this.props


        const datiClinici = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-4"}>
                        <p style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.comuneInsorgenzaSintomi")}</p>
                        <div className={styles.fieldContainer}>
                            <Autocomplete id={"comuneInsorgenzaSintomi"}
                                          value={this.state.datiClinici.comuneInsorgenzaSintomi}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"comuneInsorgenzaSintomi"}
                                          placeholder={t("SchedaSpecialeMorbillo.comuneInsorgenzaSintomi")}
                                          suggestions={this.state.comuni}
                            >
                            </Autocomplete>
                        </div>

                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.esantemaMaculoPapulare")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"esantemaMaculoPapulareSi"} name={"esantemaMaculoPapulare"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.esantemaMaculoPapulare === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"esantemaMaculoPapulareNo"} name={"esantemaMaculoPapulare"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.esantemaMaculoPapulare === "2"}>
                                </RadioButton>

                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.dataComparsaEsantema")}
                            {this.state.datiClinici.esantemaMaculoPapulare === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-3"}>
                        <Calendar
                            id={"dataComparsaEsantema"}
                            value={this.state.datiClinici.dataComparsaEsantema}
                            field={"dataComparsaEsantema"}
                            newCalendar={true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataComparsaEsantema"))}
                            error={(this.state.datiClinici.dataComparsaEsantema === "" || this.state.datiClinici.dataComparsaEsantema == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiClinici.dataComparsaEsantema), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.febbre")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"febbreSi"} name={"febbre"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.febbre === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"febbreNo"} name={"febbre"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.febbre === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.dataComparsaFebbre")}
                            {this.state.datiClinici.febbre === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""
                            }

                        </p>
                    </div>
                    <div className={"col-lg-3"}>
                        <Calendar
                            id={"dataComparsaFebbre"}
                            value={this.state.datiClinici.dataComparsaFebbre}
                            field={"dataComparsaFebbre"}
                            newCalendar={true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataComparsaFebbre"))}
                            error={(this.state.datiClinici.dataComparsaFebbre === "" || this.state.datiClinici.dataComparsaFebbre == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiClinici.dataComparsaFebbre), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
            </div>
        )

        const altriSintomi = (
            <div style={{marginTop: "1rem"}} className={"container"}>
                <p style={{color: "black", marginTop: "0.5rem"}}>
                    {t("SchedaSpecialeMorbillo.altriSintomi")}:
                </p>
                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.rinite")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"riniteSi"} name={"rinite"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.rinite === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"riniteNo"} name={"rinite"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.rinite === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.congiuntivite")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"congiuntiviteSi"} name={"congiuntivite"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.congiuntivite === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"congiuntiviteNo"} name={"congiuntivite"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.congiuntivite === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.tosse")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"tosseSi"} name={"tosse"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.tosse === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"tosseNo"} name={"tosse"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.tosse === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.adenopatia")}
                            <span className={styles.mandatoryColor}>*</span>
                            <span style={{fontWeight: "normal"}}>{t("SchedaSpecialeMorbillo.tipoAdenopatia")}</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"adenopatiaSi"} name={"adenopatia"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.adenopatia === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"adenopatiaNo"} name={"adenopatia"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.adenopatia === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.artralgia")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"artralgiaSi"} name={"artralgia"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.artralgia === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"artralgiaNo"} name={"artralgia"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.artralgia === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.artrite")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"artriteSi"} name={"artrite"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.artrite === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"artriteNo"} name={"artrite"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.artrite === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.altriSintomi")}
                            <span style={{fontWeight: "normal"}}>{t("SchedaSpecialeMorbillo.specificare")}
                                <span className={styles.mandatoryColor}>*</span>
                            </span>
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <Input
                            type={"textarea"}
                            placeholder={t("SchedaSpecialeMorbillo.altriSintomi")}
                            value={this.state.datiClinici.altro}
                            id="altro"
                            field={"altro"}
                            onChange={this.riceviValore}
                            onValidate={this.state.datiClinici.altro.startsWith(" ") ? 1 : 2} /// onValidate: 1 errore,  altro valore ok
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                t("SchedaSpecialeMorbillo.specificare"))}
                        />
                    </div>
                </div>

            </div>
        )


        const gravidanza = (

            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.inStatoGravidanza")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"statoGravidanzaSi"} name={"statoGravidanza"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiClinici.statoGravidanza === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"statoGravidanzaNo"} name={"statoGravidanza"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.datiClinici.statoGravidanza === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-7"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.dataUltimaMestruazione")}
                            {this.state.datiClinici.statoGravidanza === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""
                            }
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <Calendar
                            id={"dataUltimaMestruazione"}
                            value={this.state.datiClinici.dataUltimaMestruazione}
                            field={"dataUltimaMestruazione"}
                            newCalendar={true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataUltimaMestruazione"))}
                            error={(this.state.datiClinici.dataUltimaMestruazione === "" || this.state.datiClinici.dataUltimaMestruazione == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiClinici.dataUltimaMestruazione), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
                <p style={{marginTop: "1rem", fontWeight: "bold"}}>{t("SchedaSpecialeMorbillo.siRaccomanda")}</p>
            </div>
        )


        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.datiClinici")}</h6>
                <hr className={styles.hr}/>
                {datiClinici}
                {altriSintomi}
                {gravidanza}
            </div>
        );
    }
}

export default withTranslation('common')(DatiClinici)
